const featureToggles = {
  // Allow-list of user IDs who see gated features.
  featureFlagOverrideUserIds: [2, 341236],
  // PAYG credit purchase on pricing page (TP-187). When true and TEST_START_DATE has passed,
  // users are split A/B: even user IDs = control (PAYG hidden), odd = treatment (PAYG visible).
  paygCreditsPricingPage: false,
};

export default featureToggles;
